<template>
  <div>
    <v-slider
      v-model="currentLever"
      :min="currentLeverDetails.min"
      :max="currentLeverDetails.max"
      thumb-label
      hide-details
      dense
    ></v-slider>
    <v-row class="d-flex flex-nowrap no-gutters" style="margin-top: -16px">
      <v-col class="text-left">
        <span class="text-caption">{{ currentLeverDetails.min }}</span>
      </v-col>
      <v-col class="text-right">
        <span class="text-caption">{{ currentLeverDetails.max }}</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "FilterSlider",
  props: {
    leverKey: {
      type: String,
      default: null,
    },
  },
  computed: {
    currentLeverDetails() {
      if (!this.filtersWithCosts) {
        return null;
      }
      return this.filtersWithCosts[this.leverKey];
    },
    currentLever: {
      get() {
        if (!this.filtersWithCosts) {
          return null;
        }
        return this.filtersWithCosts[this.leverKey].value;
      },
      set(val) {
        this.setFilter([
          {
            key: this.leverKey,
            value: val,
          },
        ]);
      },
    },
    ...mapState("flags", ["hideSignals"]),
    ...mapGetters("filters", ["filtersWithCosts"]),
  },
  methods: {
    ...mapActions("filters", ["setFilter"]),
    getTickers(lever) {
      return lever.options.map((o) => o.label);
    },
    getCostString(cost) {
      return cost < 0
        ? `-$${Math.floor(Math.abs(cost))}`
        : `$${Math.ceil(cost)}`;
    },
    getAlignClass(index) {
      if (index === 0) {
        return "text-left";
      }
      if (index > 0 && index < this.currentLeverDetails.options.length - 1) {
        return "text-center";
      }
      if (index === this.currentLeverDetails.options.length - 1) {
        return "text-right";
      }
    },
  },
};
</script>
